// extracted by mini-css-extract-plugin
export var textInput = "_jg-0";